// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xJCq","comment":"styles_comment__2bT1g"};